document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
        e.preventDefault();

        // Get the target element to scroll to
        const targetElement = document.querySelector(this.getAttribute('href'));

        if (targetElement) {
            // Scroll to the target element with smooth behavior
            window.scrollTo({
                top: targetElement.offsetTop,
                behavior: 'smooth'
            });
        }
    });
});
